<ng-container *ngFor="let errorMapping of errorMappings">
  <span *ngIf="errorMapping" [attr.data-error-name]="errorMapping.errorName">
    {{errorMapping.message}}
  </span>
</ng-container>

